import { required } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    backup_total: { required },
  },
}

export const validateComputed = {
  backupErrors() {
    const errors = []
    if (!this.$v.form.backup_total.$dirty) return errors
    !this.$v.form.backup_total.required && errors.push('Opção Obrigatória')
    return errors
  },
}
